import * as ActionCreators from "./creators";
import { MESSAGING_API_URL } from "../../config";
import { navigate } from "../navigation/operations";
import fetchRetry from "../fetch_retry";

export function fetchConversations() {
  return function (dispatch, getState) {
    if (getState().messaging.loading_conversations) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingConversations());
    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(`${MESSAGING_API_URL}/conversations`, request_options)
    return fetchRetry(`${MESSAGING_API_URL}/conversations`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingConversations(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorFetchingConversations(response.message));
        } else {
          let conversations = response["results"];
          response["meta"] = response["meta"] || {};
          let last_evaluated_key = response["meta"]["last_evaluated_key"]
            ? response["meta"]["last_evaluated_key"]
            : null;
          dispatch(
            ActionCreators.fetchedConversations(conversations, response["meta"]["has_more"], last_evaluated_key)
          );
        }
      });
  };
}

export function markConversationAsRead(conversation_guid) {
  return function (dispatch, getState) {
    const payload = {
      c_guid: conversation_guid,
    };
    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(`${MESSAGING_API_URL}/conversations/read`, request_options)
    return fetchRetry(`${MESSAGING_API_URL}/conversations/read`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {}
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
        } else {
          dispatch(fetchConversations());
        }
      });
  };
}

export function fetchMessages(conversation_guid) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingMessages(conversation_guid));

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(`${MESSAGING_API_URL}/messages/${conversation_guid}`, request_options)
    return fetchRetry(`${MESSAGING_API_URL}/messages/${conversation_guid}`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingMessages(conversation_guid, error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorFetchingMessages(conversation_guid, response.message));
        } else {
          let messages = response["results"];
          let last_evaluated_key = response["meta"]["last_evaluated_key"]
            ? response["meta"]["last_evaluated_key"]
            : null;
          dispatch(
            ActionCreators.fetchedMessages(
              conversation_guid,
              messages.reverse(),
              response["meta"]["has_more"],
              last_evaluated_key
            )
          );
          dispatch(markConversationAsRead(conversation_guid));
        }
      });
  };
}

export function sendMessage(conversation_guid, message) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.sendingMessage(conversation_guid));
    const payload = {
      c_guid: conversation_guid,
      content: message,
    };
    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(`${MESSAGING_API_URL}/messages`, request_options)
    return fetchRetry(`${MESSAGING_API_URL}/messages`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorSendingMessage(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorSendingMessage(response.message));
        } else {
          dispatch(ActionCreators.sentMessage(conversation_guid));
          dispatch(fetchMessages(conversation_guid));
        }
      });
  };
}

export function createSimpleConversation(sender, receiver) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.creatingConversation(receiver["guid"]));
    const payload = {
      sender_guid: sender["guid"],
      sender_name: `${sender["f_name"]} ${sender["l_name"]}`,
      sender_thumbnail_url: sender["image_url"]
        ? sender["image_url"]
        : "https://s3.eu-central-1.amazonaws.com/ihopa-user-images/no_image.png",
      receiver_guid: receiver["guid"],
      receiver_name: `${receiver["f_name"]} ${receiver["l_name"]}`,
      receiver_thumbnail_url: receiver["image_url"]
        ? receiver["image_url"]
        : "https://s3.eu-central-1.amazonaws.com/ihopa-user-images/no_image.png",
    };
    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }
    // return fetch(`${MESSAGING_API_URL}/simple-conversation`, request_options)
    return fetchRetry(`${MESSAGING_API_URL}/simple-conversation`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorCreatingConversation(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorCreatingConversation(receiver["guid"], response.message));
        } else {
          dispatch(ActionCreators.createdConversation(response["guid"]));
          dispatch(fetchConversations());
          dispatch(navigate(`/messages/${response["guid"]}`));
        }
      });
  };
}

export function fetchConversationMembers() {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingConversationMembers());

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(`${MESSAGING_API_URL}/conversations/members`, request_options)
    return fetchRetry(`${MESSAGING_API_URL}/conversations/members`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingConversationMembers(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorFetchingConversationMembers(response.message));
        } else {
          dispatch(ActionCreators.fetchedConversationMembers(response));
        }
      });
  };
}
